var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  viewBox: "0 0 1500 1500",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-250 -250)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "a",
  cx: 1000,
  cy: 1000,
  r: 703
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 1000,
  cy: 1000,
  r: 703,
  fill: "#EDEDED",
  clipPath: "url(#b)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#DADADA",
  d: "M1469.03 692.63H747.51L569.09 871.06v957.91c0 41.89 33.96 75.85 75.85 75.85h824.09c41.89 0 75.85-33.96 75.85-75.85V768.49c.01-41.89-33.96-75.86-75.85-75.86"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9C",
  d: "M1469.03 1914.32H644.94c-47.06 0-85.35-38.29-85.35-85.35V871.06c0-2.52 1-4.94 2.78-6.72L740.8 685.92a9.5 9.5 0 0 1 6.72-2.78h721.52c47.06 0 85.35 38.29 85.35 85.35v1060.48c0 47.06-38.29 85.35-85.36 85.35M578.59 874.99v953.98c0 36.59 29.77 66.35 66.35 66.35h824.09c36.59 0 66.35-29.77 66.35-66.35V768.49c0-36.59-29.77-66.35-66.35-66.35H751.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M1487.9 807.48v957.91c0 41.89-33.96 75.85-75.85 75.85h-824.1c-41.89 0-75.85-33.96-75.85-75.85V704.91c0-41.89 33.96-75.85 75.85-75.85h721.52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADADA",
  d: "M1487.9 807.48h-102.57c-41.89 0-75.85-33.96-75.85-75.85V629.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9C",
  d: "M1412.04 1850.75H587.95c-47.06 0-85.35-38.29-85.35-85.35V704.91c0-47.06 38.29-85.35 85.35-85.35h721.52c2.52 0 4.94 1 6.72 2.78l178.43 178.43a9.5 9.5 0 0 1 2.78 6.72v957.91c0 47.06-38.29 85.35-85.36 85.35M587.95 638.56c-36.59 0-66.35 29.77-66.35 66.35v1060.48c0 36.59 29.77 66.35 66.35 66.35h824.09c36.59 0 66.35-29.77 66.35-66.35V811.42l-172.86-172.86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9C",
  d: "M1487.9 816.98h-102.57c-47.06 0-85.35-38.29-85.35-85.35V629.06c0-3.84 2.31-7.31 5.86-8.78a9.49 9.49 0 0 1 10.35 2.06l178.43 178.42a9.49 9.49 0 0 1 2.06 10.35 9.5 9.5 0 0 1-8.78 5.87m-168.93-164.99v79.64c0 36.59 29.77 66.35 66.35 66.35h79.64z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1000,
  cy: 1099.01,
  r: 199.72,
  fill: "#DADADA"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9C",
  d: "M1000 1133.32c-2.47 0-4.9-.96-6.72-2.78l-61.01-61.01c-3.71-3.71-3.71-9.73 0-13.44a9.494 9.494 0 0 1 13.43 0l44.79 44.79V981.36c0-5.25 4.25-9.5 9.5-9.5s9.5 4.25 9.5 9.5v142.46c0 3.84-2.31 7.31-5.86 8.78-1.17.49-2.4.72-3.63.72"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9C",
  d: "M1000 1133.32c-1.22 0-2.46-.24-3.63-.72a9.49 9.49 0 0 1-5.86-8.78V981.36c0-5.25 4.25-9.5 9.5-9.5s9.5 4.25 9.5 9.5v119.53l44.79-44.79c3.71-3.71 9.72-3.71 13.44 0 3.71 3.71 3.71 9.73 0 13.44l-61.01 61.01a9.57 9.57 0 0 1-6.73 2.77"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9C",
  d: "M1094.75 1174.6h-189.5c-5.25 0-9.5-4.25-9.5-9.5v-26.63c0-5.25 4.25-9.5 9.5-9.5s9.5 4.25 9.5 9.5v17.13h170.51v-17.13c0-5.25 4.25-9.5 9.5-9.5s9.5 4.25 9.5 9.5v26.63c-.01 5.25-4.26 9.5-9.51 9.5"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DADADA",
  d: "M1067.77 1187.6H432.23c-18.14 0-32.84-14.7-32.84-32.84s14.7-32.84 32.84-32.84h635.54c18.14 0 32.84 14.7 32.84 32.84s-14.7 32.84-32.84 32.84"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9C",
  d: "M913.8 1164.26H435.37c-5.25 0-9.5-4.25-9.5-9.5s4.25-9.5 9.5-9.5H913.8c5.25 0 9.5 4.25 9.5 9.5s-4.26 9.5-9.5 9.5"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.e3712a09ff4fb98b657ba26ea2b7d18a.svg";